import { isString } from '@k2/common/helpers';
import { Action } from '@ngrx/store';

/**
 * Checks if a given value is a store action.
 */
export function isAction(value): value is Action {
  return value && isString(value.type);
}
